import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '@base/environments/environment';
import { HttpService } from '@base/src/app/core/http.service';

@Injectable({
  providedIn: 'root',
})
export class ReservometroStatisticsService extends HttpService {
  constructor(public override http: HttpClient) {
    super(http);
    this.url = '/statistics';
    this.baseUrl = environment.apiEndpoint;
  }
}
